// import html2canvas from '../../../../node_modules/html2canvas/dist/html2canvas.js'
import html2canvas from 'html2canvas'

export default {
  methods: {
    mixinSaveAsPng ({ filename, saveId, filterClass }) {
      const node = document.getElementById(saveId)
      const filter = el => el.classList ? el.classList.contains(filterClass) : false

      html2canvas(node, {
        logging: false,
        ignoreElements: filter,
        backgroundColor: null
      })
      .then(canvas => {
        // IE case
        if (canvas.msToBlob) {
          const blob = canvas.msToBlob()
          window.navigator.msSaveBlob(blob, `${filename}.png`)
        } else {
          const link = document.createElement('a')
          link.download = `${filename}.png`
          link.href = canvas.toDataURL('image/png')
          link.opacity = '0';
          document.body.appendChild(link);
          link.click()
        }
      })
      .catch(err => {
        console.log(err)
        err.message = this.$tr('analytics.widgets.saveError')
        this.$store.dispatch('global/setError', err)
      })
    }
  }
}
